import { z } from "zod";
import type { DiscoveredLoot } from "@frontier/content/contracts";

export const discoveredLootSchema = z
  .array(
    z
      .object({
        id: z.string().min(1).max(100),
        kind: z.literal("salvage"),
        x: z.number().finite(),
        y: z.number().finite(),
        value: z.number().int().nonnegative(),
        pending: z.boolean(),
      })
      .strict(),
  )
  .max(16) satisfies z.ZodType<DiscoveredLoot[]>;

export const discoveriesViewSchema = z
  .object({
    runId: z.string().min(1),
    loot: discoveredLootSchema,
  })
  .strict();
export type DiscoveriesView = z.infer<typeof discoveriesViewSchema>;
